import ReactDOM from 'react-dom/client';
import App from './app/App';

let redirect = false;
let isLoggedIn = window.localStorage.getItem('RefreshEmail') != null;
let allowedPages = ['/login', '/signup'];

if(!allowedPages.includes(window.location.pathname) && !isLoggedIn) { 
  let subdomain = 'www';
  let parts = window.location.host.split('.');

  if(window.location.host.indexOf('localhost') == -1) 
    subdomain = parts.length > 2 ? parts[0] : 'www';
  else 
    subdomain = parts.length > 1 ? parts[0] : 'www';

  if(subdomain == 'www') {
    window.location.replace('https://marketing.oneclick.community');
    redirect = true;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if(!redirect) {
  root.render(
    <App />
  );
}
